import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography } from '@mui/material';
import { AppWidgetSummary } from '../sections/@dashboard/app';
import WelcomeModal from '../components/WelcomeModal';

export default function DashboardAppPage() {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setOpenModal(true);
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Helmet>
        <title> Dashboard | EP - Aguas de Manta </title>
      </Helmet>

      <WelcomeModal open={openModal} onClose={handleCloseModal} />

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hola, bienvenido de nuevo.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="GRP K2B" subtitle="Sistema Financiero" icon={'ion:infinite-outline'} link="http://192.168.10.253:8080/K2BGAM/servlet/com.k2bgam.k2blogin" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="ACIIS" subtitle="Sistema Comercial" color="info" icon={'uim:graph-bar'} link="https://epam.altura.services/aportal/l/es/aportal.jsp" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="GIRH WEB" subtitle="Gestion de Talento Humano" color="warning" icon={'uim:bag'} link="http://192.168.10.243:8080/dlportal/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="ZIMBRA" subtitle="Correo electronico institucional" color="secondary" icon={'uim:at'} link="https://mail.epam.gob.ec" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="NAS" subtitle="Sistema de Almacenamiento" color="success" icon={'uim:layers-alt'} link="http://192.168.10.164:5000/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="OWNCLOUD" subtitle="Servicio de alojamiento" color="error" icon={'uim:apps'} link="https://192.168.10.183/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="ODK" subtitle="Servidor de Encuestas" color="secondary" icon={'mdi:form-select'} link="http://encuestas.epam.gob.ec/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="GESTOR" subtitle="Sistema Integral de Planificación" icon={'uim:bars'} link="https://sistemasic.manta.gob.ec/login" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="GACETA" subtitle="Gaceta Tributaria" color="info" icon={'uim:layer-group'} link="http://192.168.10.89:3000" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="EPAM" subtitle="Sitio Web Institucional" color="warning" icon={'ri:building-4-line'} link="https://www.epam.gob.ec" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="MAYAN" subtitle="Gestión de Documentos" color="info" icon={'solar:document-text-bold-duotone'} link="http://66.94.124.29/authentication/login/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="PORTAL EPAM" subtitle="Servicios en linea" color="success" icon={'iconamoon:file-document-thin'} link="https://portal.epam.gob.ec" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="AQUA" subtitle="Sistema Historico de Consultas" icon={'ion:water'} link="http://192.168.10.5/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="CONSULTA DE DATOS" subtitle="Consulta de datos Dinardap" color="secondary" icon={'mdi:sql-query'} link="http://192.168.10.89:3005/dashboard/login" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="BOLSA DE TRABAJO" subtitle="Sistema de Postulaciones" icon={'fluent-mdl2:workforce-management'} link="http://192.168.10.247:9002/girhr-postulaciones/servlet/hbolsa_trabajo" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="GDM" subtitle="Gestión de Mantenimiento" color="error" icon={'solar:help-bold-duotone'} link="http://192.168.10.253:8080/gdm/servlet/home" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="CALIDAD" subtitle="Gestión de Calidad" color="warning" icon={'raphael:lab'} link="http://192.168.10.253:8080/calidad/servlet/homelogin" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="RETENCIONES" subtitle="Consultas de Comprobantes" color="info" icon={'mingcute:pdf-line'} link="http://192.168.30.191/consultas/comprobantes.html" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="SOPHOS" subtitle="Firewall" icon={'iconoir:pc-firewall'} link="https://192.168.10.100:4444/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="OCS" subtitle="Inventario Tecnologico" color="secondary" icon={'ic:outline-inventory'} link="http://192.168.10.89/ocsreports/" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="SUPERSET" subtitle="Exploracion y Visualizacion BI" color="error" icon={'solar:help-bold-duotone'} link="http://192.168.10.93:8088/login/" />
          </Grid>
		  <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="DEFUNCIONES" subtitle="Consulta de estado de fallecimiento" color="warning" icon={'mdi:cross'} link="http://192.168.10.89:3061" />
          </Grid>
		  <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="REUNIONES" subtitle="Control de Reuniones" color="warning" icon={'ic:outline-inventory'} link="http://192.168.10.89:3063" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}